export default __webpack_public_path__ + "static/media/68a08e301eefa152ef224a70485326d2.svg";